module.exports = __webpack_public_path__ + "static/img/juan-yi-1.46a98eda.png";